import { PkDivider } from '@uefadigital/panenka-react';
import parseHtmlToReact from 'html-react-parser';
import { memo, useMemo } from 'react';

import { useCoefficients } from '../../hooks/coefficients';
import { useCoefficientsConfig } from '../../hooks/configuration';
import { handlePopoverPageTracking } from '../../utils/tracking';

import { useTranslateFn } from '@shared/Translate';
import { dateToString } from '@utilities/dateTime';

const Footer = () => {
  const {
    configuration: { highlightTagDisclaimer, howToReadRankingTag, path, editorialContent },
  } = useCoefficientsConfig();

  const { lastUpdateDate } = useCoefficients();
  const t = useTranslateFn();
  const howToReadRankingTagClean =
    useMemo(() => t(howToReadRankingTag)?.replace(/<a.*>.*<\/a>/gm, ''), [howToReadRankingTag, t]) ?? '';

  const setupModal = (el: HTMLElement) => {
    el?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector<HTMLPkDialogElement>('#coefficient-about-dialog')?.open();
      handlePopoverPageTracking(path);
    });
  };

  return (
    <div className='pk-pt--m pk-pt-sm--l pk-d--flex pk-flex--column pk-gap--m pk-gap-sm--l'>
      {!!lastUpdateDate && (
        <>
          <div className='pk-font-size--xs pk-text--text-03'>
            {t('last_updated')}: {dateToString(lastUpdateDate, 'DD/MM/YYYY HH:mm')}
          </div>
          <PkDivider className='pk-m--0' />
        </>
      )}
      {!!highlightTagDisclaimer && (
        <>
          <div className='pk-font-size--xs'>{parseHtmlToReact(t(highlightTagDisclaimer))}</div>
          <PkDivider className='pk-m--0' />
        </>
      )}

      <div>
        <h3 className='pk-mb--s pk-font-size--l pk-font--base-bold'>{t('about_the_ranking')}</h3>
        <p className='pk-m--0 pk-font-size--s'>
          <span>{t(howToReadRankingTagClean)}</span>
          {!!editorialContent && (
            <a href='/#' title={t('learn_more')} ref={setupModal}>
              {t('learn_more')}
            </a>
          )}
        </p>
      </div>
      <PkDivider className='pk-m--0' />

      <div className='pk-font-size--xs pk-text--text-03'>{parseHtmlToReact(t('coefficient_message'))}</div>
    </div>
  );
};

export default memo(Footer);
